import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import PurpleInfo from '../../../../Shared/PurpleInfo/PurpleInfo';
import Config from '../../../../../Config';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import alertIcon from '../../images/alert-yellow.svg';

const PackageBox = (props) => {
    const packageName = props.package?.cmsData?.selfCare?.title ? props?.package?.cmsData?.selfCare?.title : props.package?.localizedName;

    const packageImage = () => {
        let packageImage = props.defaultImage;
        if (isMobile) {
            if (props.package.cmsData?.selfCare?.mobileImage) {
                packageImage = props.package.cmsData?.selfCare?.mobileImage;
            }
        }
        else {
            if (props.package.cmsData?.selfCare?.desktopImage) {
                packageImage = props.package.cmsData?.selfCare?.desktopImage;
            }
        }
        if (props.type == 'newPackages') {
            return (<Image className='package-image' src={Config.epiBaseUrl + packageImage} alt='package image' />)
        }
        else {
            return (< div style={{ backgroundImage: `url(${Config.epiBaseUrl + packageImage})`, width: '100%', height: '100%', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} />);
        }
    }

    const displayMonthlyOrDaily = () => {
        let premiumPackage = props.package;
        if (premiumPackage?.vasList) {
            let existingVas = premiumPackage?.vasList?.find(x => x.action == "Existing");
            if (existingVas) {
                premiumPackage = existingVas;
            }
        }
        if (premiumPackage?.expirationDate) {
            let date = moment(premiumPackage.expirationDate, "YYYYMMDD")?.format("DD.MM.YYYY");
            let duration = premiumPackage.duration.amount;
            let durationText = 'יום אחד';
            if (duration > 1) {
                durationText = duration + " ימים";
            }
            return <div className='text-wrapper'>
                <div className='text'> מנוי חד פעמי עבור {durationText}</div>
                <div className='text'>מסתיים ב - {date}</div>
            </div>
        } else {
            return <div className='text-wrapper'><div className='text'>מנוי חודשי</div></div>;
        }
    };

    const getSpecialPrice = () => {
      if(props.package.priceItemList?.length > 0){
        return (<div className='price-wrapper'>
          {props.package.priceItemList.map((item, index) => {
            return (
              <div className='price-row' key={index}>
                {index == 0 ? <div className='first-row'><span>₪</span><span className='price'>{item.price}</span> {item.priceText}</div> :
                <div className='text'>{item.priceText} {index != 0 &&  '₪' + item.price } לחודש</div> }
              </div> )
          })}
        </div>)
      }
      else if(props.package.price != props.package.originalPrice){
        return (<div className='price-wrapper'>
          <div className='price-row'>₪<span className='price'>{props.package.price}</span> לחודש</div>
          <div className='price-row'>במקום <span className='original-price'>₪<sapn className="price">{props.package.originalPrice}</sapn></span> לחודש</div>
        </div>)
      }else{
        return null;
      }
    }

    const getPrice = () => {
        const packages = props.package.vasList?.length > 0 ? props.package.vasList :
            props.package.premiumPackages?.length > 0 ? props.package.premiumPackages : [props.package];
        if(packages.length == 1){
          const specialPrice = getSpecialPrice();
          if(specialPrice != null){
            return specialPrice;
          }
        }
        const minimumPrice = Math.min(...packages.map(item => item.price));
        const maximumPrice = Math.max(...packages.map(item => item.price));
        if(maximumPrice == 0 && minimumPrice == 0){
          return (<div className='price'>ללא עלות</div>)
        }
        else if (minimumPrice < maximumPrice) {
            return (<div className='price'>החל מ - ₪{minimumPrice}</div>)
        }
        else if (minimumPrice == maximumPrice) {
            return (<div className='price'>₪{minimumPrice} לחודש</div>)
    }
    }

    const isHboWithBanner = props.package?.action?.toLowerCase() === "existing" && props.package.cmsData?.id?.toLowerCase?.().includes('hbo') && props?.package?.provisionStatus === "B";
    const isDisneyWithBanner = props.package?.action?.toLowerCase() === "existing" && props.package.cmsData?.id?.toLowerCase?.().includes('dis') && props?.package?.provisionStatus === "B";
    const isDisneyExistingAccountBanner = props.package?.action?.toLowerCase() === "existing" && props.package.cmsData?.id?.toLowerCase?.().includes('dis') && props?.package?.provisionStatus === "D";
    const hasStreamingBanner = isHboWithBanner || isDisneyWithBanner || isDisneyExistingAccountBanner;

    return (<>
        <div className={`package-box${hasStreamingBanner ? ' has-hbo-banner' : ''}`} data-package-name={props.package.name} >
        {props.type == 'newPackages' ?
            <div className='new-package-box'>
                {packageImage()}
                <div className='details-right'>
                    <div className='tag-wrapper'>
                        {
                            props.package.cmsData?.selfCare?.labelText &&
                            <div className='tag-text'>
                                {props.package.cmsData?.selfCare?.labelIcon && <Image className='tag-icon' alt='אייקון טגית' src={Config.epiBaseUrl + props.package.cmsData?.selfCare?.labelIcon} />}
                                {props.package.cmsData?.selfCare?.labelText}
                            </div>
                        }
                    </div>
                    <div className='title'>{packageName}</div>
                    {getPrice()}
                </div>
                <div className='details-left'>
                    <BtnSubmit text="לפרטים ורכישה" onclick={() => props.onClick(props.package)} />
                </div>
            </div> : //SUBSCRIBER PACKAGE
            <div className='subscriber-package-box'>
                <div className='details-right'>
                    <div className='title'>{packageName}</div>
                    {displayMonthlyOrDaily()}
                    <a href='#' onClick={() => props.onClick(props.package)}>לפרטי החבילה</a>
                </div>
                <div className='details-left'>
                    {packageImage()}
                </div>
            </div>
        }
        </div>
        {isHboWithBanner && (
            <div className='hbo-registration-banner'>
                <PurpleInfo text={<>כדי לצפות בתכנים יש<br />ליצור חשבון ב-HBO Max</>}>
                    <BtnSubmit text='ל-HBO Max' onclick={props.onHboRegistrationClick} />
                </PurpleInfo>
            </div>
        )}
        {isDisneyWithBanner && (
            <div className='hbo-registration-banner'>
                <PurpleInfo text={<>כדי לצפות בתכנים יש<br />ליצור חשבון בדיסני+</>}>
                    <BtnSubmit text='לדיסני+' onclick={props.onDisneyRegistrationClick} />
                </PurpleInfo>
            </div>
        )}
        {isDisneyExistingAccountBanner && (
            <div className='hbo-registration-banner returning-customer-banner'>
                <PurpleInfo text={
                    <span className='returning-customer-banner__content'>
                        <span className="provisioning-page__info-icon-wrapper">
                            <Image src={alertIcon} alt="" className="provisioning-page__info-icon" />
                        </span>
                        <span>
                            זיהינו שכבר היה לך חשבון דיסני+,<br />יש להתחבר עם החשבון שנרשמת <br />איתו כדי להתחיל ולצפות בתכנים
                        </span>
                    </span>
                }>
                    <BtnSubmit text='לדיסני+' onclick={props.onDisneyRegistrationClick} />
                </PurpleInfo>
            </div>
        )}
    </>);
}

export default PackageBox;
